import * as constants from "../helper/constants";

// Disable animation for mobile

export default function disableAnimationForMobile(isVisible) {
    if(window.innerWidth < constants.MOBILE_WIDTH) {
       return true;
    }
    return isVisible;
}